import React from 'react';
import SubscriptionDetails from '../components/SubscriptionDetails';

const SubscriptionsPage = () => <SubscriptionDetails />;

export default SubscriptionsPage;
